import React from 'react'

import { string, shape } from 'prop-types'

import CircledArrowRight from 'Pods/Shared/Icons/CircledArrowRight'
import ModelIcon from 'Pods/Shared/ModelIcon/ModelIcon'

function TypeFilterItem({ item }) {
  const itemUrl = item.icon === 'printable' ? `${item.path}?page=1` : item.path

  return (
    <a href={itemUrl} className="filter-item type-filter-item">
      <div className="filter-item__content">
        <div className="filter-item__icon-container">
          <ModelIcon icon={item.icon} width="24" height="24" />
        </div>
        <span className="filter-item__name">{item.name}</span>
        <div className="filter-item__count">{item.count}</div>
      </div>
      <div className="filter-item__icon-wrapper">
        <CircledArrowRight width="24" height="24" />
      </div>
    </a>
  )
}

TypeFilterItem.propTypes = {
  item: shape({
    name: string.isRequired,
    count: string.isRequired,
    icon: string.isRequired,
    path: string.isRequired,
  }).isRequired,
}

TypeFilterItem.displayName = 'TypeFilterItem'

export default TypeFilterItem
